import { LinkItem } from "component/w24/component/LinkItem"
import React from "react"
import styled from "styled-components/macro"

interface Props {
  selectedIndex: number
  items: string[]
  className?: string
  onSelected?: (index: number) => void
}

export const ChoiceMenu = (props: Props): JSX.Element => {
  return (
    <S_ChoiceMenu className={props.className}>
      {props.items.map((item, index) => {
        return (
          <S_LinkItem
            key={item}
            title={item}
            choiceItem={index === props.selectedIndex ? "fill" : "border"}
            onClick={() => {
              if (props.onSelected) {
                props.onSelected(index)
              }
            }}
          />
        )
      })}
    </S_ChoiceMenu>
  )
}

const S_ChoiceMenu = styled.div`
  display: flex;
  gap: 30px 40px;
  flex-wrap: wrap;
  width: 300px;
  justify-content: center;
  @media only screen and (min-width: 1260px) {
    width: 100%;
  }
`

const S_LinkItem = styled(LinkItem)`
  min-width: 115px;
  @media only screen and (min-width: 1260px) {
    width: unset;
    min-width: unset;
  }
`
